import { Controller } from "@hotwired/stimulus"

// Sets a cookie when the user changes the view select so the server can
// remember the preference on the next visit.
export default class extends Controller {
  setView(event) {
    const view = event.currentTarget.value
    if (view) {
      document.cookie = `cards_view=${view}; path=/; max-age=${60 * 60 * 24 * 365}`
    }
  }
}
